import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'empathy-end-page-view',
  templateUrl: 'end-page-view.component.html',
  styleUrls: ['./end-page-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EndPageViewComponent {
  endPage = input<{ html: string; buttonText: string }>();
  completed = output<void>();
}
